import { WEB_URL } from "@/config/endpoints";
import IMAGES from "@/public/assets/img";

export default {
  SeoContent:{
        title: 'Global Supply Chain Finance Company in India | Innovative Solution',
        url: WEB_URL,
        description:'Credlix is a digital Global Supply Chain Finance Company in India from Moglix that provides quick, collateral-free working capital solutions for the entire supply chain.',
        keyword: 'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company', 
        imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
    indiaBanner:true,
    HomeNewData :{
        banner: {
            mainHeading : "Fast Invoice Financing & Working Capital \n for Domestic and EXIM Businesses",
            domesticCta: 'Domestic Financing',
            exportCta: 'Export Financing',
        },
    
        subSolutionsSec:{
            heading:'Empowering Businesses to Reach New Heights: <span class="font-semibold inline-block"> Factoring, the Superior Alternative to Loans </span>',
            paragraph:'Providing businesses with immediate access to cash by leveraging their accounts receivable.',
            src: IMAGES.HomeNew.termsheetClock,
            ctaHref:'/export-factoring/buyer-credit-check',
            ctaText:'Generate term sheet in 5 mins',
            ctaText2:'Generate termsheet',
            subSolutions:[
                {heading:'Vendor Finance',href: '/enterprise/vendor-financing-india', src:IMAGES.HomeNew.vendorFinance},
                {heading:'Dealer Finance', src:IMAGES.HomeNew.dealerFinance},
                {heading:'Channel Finance',href: '/enterprise/channel-financing-india', src:IMAGES.HomeNew.channelFinance},
                {heading:'Buyer Finance', src:IMAGES.HomeNew.buyerFinance},
                {heading:'Last Mile Finance', src:IMAGES.HomeNew.lastMileFinance},
                {heading:'Import Financing', src:IMAGES.HomeNew.importFinancing},
            ]
    
        }
    },
    CTASection:{
        heading: 'Check Your Buyer’s Creditworthiness Instantly.​',
        paragraph:'Add a buyer and Download their eligibility report​',
        cta: 'Get Free Buyer Report​',
        paragraphMobile:'Add buyer details & verify eligibility in 2 mins.​',
        para2Mobile:'Download Free Report.​',
        ctaMobile:'Verify Buyer Eligibility​​',
        ctaLink:'/export-factoring/buyer-credit-check'
    },
    SolutionsSec:{
        heading:'Experience a game-changing approach to supply chain <span class="font-semibold inline-block">financing with Credlix</span>!',
        paragraph:'We enable tailored financing solutions powered by cutting-edge tech and an extensive lending network for your business.',
        learnmoreCta : 'Learn More',
        solutions:[
            {heading:'Export Factoring',paragraph:'Avail non-recourse factoring up to 90% of Invoice value for buyers in 90+ countries from Credlix up to 120 days',src:IMAGES.SHARED.eFinance, color:'#FCE2E8', href: '/export-factoring',eventName:'Learn_More_Export_Factoring'},
            {heading:'PO Finance',paragraph:'Avail financing against confirmed purchase orders from Credlix. Both domestic & export orders (up to 90 days).',src:IMAGES.SHARED.poFinane, color:'#DBFFF9', href: '/export-factoring/purchase-order-financing',eventName:'Learn_More_PO_Finance'},
            {heading:'Sales Bill Discounting',paragraph:'Avail financing against your domestic sales to Buyers (preferably large customers) up to 120 days.',src:IMAGES.SHARED.sbDiscount, color:'#D5E8FF', href: '/export-factoring/invoice-discounting-platform', eventName:'Learn_More_Sales_Bill_Discounting'},
            {heading:'Early Payment',paragraph:'For Anchor customers, avail vendor financing solution tailor made for your business.',src:IMAGES.SHARED.ePayment, color:'#FFF6D3', href: '/enterprise/early-payment-discount', eventName:'Learn_More_Early_Payment'},
        ]
    
    },
    SubSolutionsSec:{
        heading:null,
        para1:null,
        headingIndia:'Empowering Businesses to Reach New Heights: <span class="font-semibold inline-block"> Factoring, the Superior Alternative to Loans</span>',
        para2:'Factoring provides fast access to working capital by unlocking the value of your unpaid invoices. Unlike loans, it doesn’t add debt. Improve cash flow, seize new opportunities, and grow without waiting for customer payments. It’s smart, flexible, and designed to fuel your business growth.',
        para3:null,
        para4:null,
        // src: IMAGES.HomeNew.termsheetClock,
        ctaHref:null,
        ctaText:null,
        subSolutions:[],
        FooterIndiaForm:true,
        // subSolutions:[
        //     {heading:'Vendor Finance',href: '/enterprise/vendor-financing-india', src:IMAGES.HomeNew.vendorFinance,para:null},
        //     {heading:'Dealer Finance', src:IMAGES.HomeNew.dealerFinance},
        //     {heading:'Channel Finance',href: '/enterprise/channel-financing-india', src:IMAGES.HomeNew.channelFinance,para:null},
        //     {heading:'Buyer Finance', src:IMAGES.HomeNew.buyerFinance,para:null},
        //     {heading:'Last Mile Finance', src:IMAGES.HomeNew.lastMileFinance,para:null},
        //     {heading:'Import Financing', src:IMAGES.HomeNew.importFinancing,para:null},
        // ]

    },
    ConuterSec:{
        heading:'From Local Roots To Global Expansion',
        paragraph:'Credlix Empowers MSME Growth',
        bannerImg : IMAGES.HomeNew.numbersBg,
        bannerMbImage:IMAGES.HomeNew.numbersBgMobile,
        counterList:[
            {heading:'75,000', paragraph:'Invoice Funded', smalltext:'+'},
            {heading:'5000', paragraph:'MSMEs Onboarded', smalltext:'+'},
            {heading:'$1', paragraph:'Export Financing', smalltext:'Bn+'},
            {heading:'120', paragraph:'Cities Coverage', smalltext:'+'}
        ]
    },
    CapitalSolution:true,
    CapitalSolutionSec:{
        heading:'Tailored Capital Solutions for <span class="font-semibold inline-block"> Your Business</span>',
        paragraph:'Unlock up to 90% of your invoice value with Credlix. Get instant, collateral-free working capital to improve cash flow, shorten receivable cycles, and power growth across domestic and EXIM supply chains.',
        bannerImg : IMAGES.HomeNew.newVideoBanner,
        bannerAltText : "Credlix Haina Banner",
        ctaText:'Apply for Instant Financing',
        capitalSolutionList:[
            {text:'<p>Funds up to<strong> 40 Cr. </strong>in 48 Hours </p>', color:'#FCE2E8', src:IMAGES.HomeNew.funds, alt:'funds'},
            {text:'<p><strong> Zero </strong>Collateral needed</p>', color:'#DBFFF9',src:IMAGES.HomeNew.securityLoan, alt:'Security Loan'},
            {text:'<p>Working capital Up to<strong> 90% </strong>of Invoice</p>', color:'#D5E8FF',src:IMAGES.HomeNew.workingCapital, alt:'Working Capital'},
            {text:'<p>Manage<strong> Multiple </strong>Credit Lines</p>', color:'#FFF6D3',src:IMAGES.HomeNew.credit , alt:'Credit'},
            {text:'<p><strong> Hassle Free </strong>Process</p>', color:'#E7F2FF',src:IMAGES.HomeNew.hassleFree, alt:'Hassle Free'},
            {text:'<p><strong> Secure </strong>& Reliable</p>', color:'#EFFFEA',src:IMAGES.HomeNew.secure, alt:'Secure'}
        ],
        subHead:'Ready to Take Your Business to the Next Level?',
        subParagraph:'Get hassle free financing for your business',
    },
    BookAMeeting:'Book a Meeting Now',
    HowItWorks:null,
    Investers:{
        heading:'We are backed by global investors',
        investerslList:[
            {src:IMAGES.HomeNew.sequoiaNew, alt:'Sequoia'},
            {src:IMAGES.HomeNew.accelNew, alt:'accel'},
            {src:IMAGES.HomeNew.falconNew, alt:'falcon'},
            {src:IMAGES.HomeNew.havardNew, alt:'havard'},
            {src:IMAGES.HomeNew.tigerNew, alt:'tiger'},
            {src:IMAGES.HomeNew.jungleNew, alt:'jungle'},
            {src:IMAGES.HomeNew.falconEdge, alt:'falcon Edge'},
            {src:IMAGES.HomeNew.tigerGlobal, alt:'Tiger Global'},
            {src:IMAGES.HomeNew.seedPlus, alt:'Seed Plus'},
            {src:IMAGES.HomeNew.compositeCapital, alt:'Composite Capital'},
            {src:IMAGES.HomeNew.infinanceCorp, alt:'IFC'},
            
        ],
    },
    GlobalNetwork:{
      heading:'Our <strong>Global Network</strong> <br/>Enable Faster Results',
      para:'With offices in India, USA, UAE, and Mexico regions, Credlix offers localized support and expertise to clients worldwide.',
      flags:[
        {flag:IMAGES.HomeNew.indiaFlag,name:'India'},
        {flag:IMAGES.HomeNew.mexicoFlag,name:'Mexico'},
        {flag:IMAGES.HomeNew.singaporeFlag,name:'Singapore'},
        {flag:IMAGES.HomeNew.usaFlag,name:'USA'},
        {flag:IMAGES.HomeNew.uaeFlag,name:'UAE'},
      ]
    },
    WhyChooseCredlix:true,
    Credibility:{
        heading:'Credibility You Can Trust',
        subHeading:'Backed by industry recognition',
        awards:[
            IMAGES.HomeNew.award1,IMAGES.HomeNew.award2,IMAGES.HomeNew.award3,IMAGES.HomeNew.award4,IMAGES.HomeNew.award5,IMAGES.HomeNew.award6,
            IMAGES.HomeNew.award7,IMAGES.HomeNew.award8,IMAGES.HomeNew.award9,IMAGES.HomeNew.award10,IMAGES.HomeNew.award11,IMAGES.HomeNew.award12
          ],
    },
    Testimonial:true,
    Customers:{
        heading:'Our Happy Clients',
        paragraph: 'What they say about us',
        knowMoreCta: 'Know more',
        customersList:[
            {CustomerQuote:"We significantly improved our suppliers' cash cycle, allowing efficient invoice-to-cash processing", CustomerName:'Aditya Birla', CustomerDesignation:'Aditya Birla || Fashion & Retail', cta:'CredlixCasestudyAditya', src:IMAGES.HomeNew.adityaImg, },
            {CustomerQuote:'Their understanding and knowledge of financing solutions have been valuable for our business.',CustomerName:'Deepak Gaur Sharma', CustomerDesignation:'MD || Accord', cta:'CredlixCasestudyAccord', src:IMAGES.HomeNew.accordImg},
            {CustomerQuote:'Manufacturing company automates supply chain financing',CustomerName:'Ishita Bowry',CustomerDesignation:'Director - Finance ||TwigaFiber', cta:'CredlixCasestudyTwigafiber', src:IMAGES.HomeNew.twigaImg},
            {CustomerQuote:'The entire process of working with the Credlix team has been easy and end-to-end digital.',CustomerName:'Ujwal Desai',CustomerDesignation:'CEO & Founder || Lucro', cta:'CredlixCasestudyUjwal', src:IMAGES.HomeNew.lucroImg},
            {CustomerQuote:'Food processing company adds significant value to its supply chain',CustomerName:'Vinod Jobanputra',CustomerDesignation:'CEO & Founder || Lalsai Dehy Foods', cta:'CredlixCasestudyVinod', src:IMAGES.HomeNew.vinodImg},
        
          ]
      },
    blogShow:true,
    DownloadApp:true,
    FAQ:{
        Faq_heading:'Frequently Asked Questions',
        Home_Faq:[
            {   id:0,
              Q:"What is Supply Chain Finance?",
              A:"Any private or public entity is eligible to avail supply chain finance. Sole proprietorship and partnership companies can also use this facility. Supply chain finance is like a high-tech helper for businesses that makes deals smoother, hassle-free, and more cost-effective. It's a set of smart processes using technology to bring down expenses and make things work better for everyone in a business deal. It’s like a tool that helps buyers and sellers in a transaction save money and do things faster."
            },
            {   id:1,
              Q:"What are the Documents Required for Supply Chain Finance?",
              A:"The documents required for supply chain finance is as follows:",
              list:["Identity proof","Address proof","Financial documents","Business ownership documents."]
            },
            {   id:2,
              Q:"What are the Types of trading services offered under Supply Chain Finance?",
              A:"The Types of trading services offered under Supply Chain Finance are as follows:",
              list:["Invoice Discounting","Dynamic Discounting","Supply Chain Financing Platforms","Receivables Finance","Payables Financing","Inventory Financing","Purchase Order Financing","Channel Financing"]
            },
            {   id:3,
              Q:"What is the Eligibility Criteria for Supply Chain Finance?",
              A:"To be able to avail of supply chain financing, the eligibility criteria is as follows:",
              list:["Creditworthiness","Indian Nationality","Business Vintage of at least 3 years","Transaction Volume","Trade Relationship","Invoices and Receivables","Supply Chain Visibility","Compliance","Financial Health","A good CIBIL score"]
            },
            {   id:4,
              Q:"What is the Interest Rates for Supply Chain Finance?",
              A:"There’s no one fixed rate of interest for supply chain finances. It depends on several factors like the provider, companies trustworthiness, creditworthiness, market conditions, and more. The interest rate is mostly competitive in nature."
            },
            {   id:5,
              Q:"How can one apply for Supply Chain Finance?",
              A:"",
              list:["Step 1: Login to our website https://www.credlix.com/","Step 2: Give all the necessary information required. ","Step 3: Go through the eligibility criteria thoroughly. ","Step 4: Agree on the financing terms with Credlix.","Step 5: The final approval."]
            },
            {   id:6,
              Q:"What are the Features & Benefits of Supply Chain Finance?",
              A:"Features and benefits of supply chain finance:",
              list:["Good working capital and cash flow ","Better inventory management. ","Good returns","Low cost","Digital, fast, and safe process","Up to 90% of invoices financed","No-collateral is required"]
            },
            {   id:7,
              Q:"Who all can avail Supply Chain Finance?",
              A:"Any private or public entity is eligible to avail supply chain finance. Sole proprietorship and partnership companies can also use this facility. "
            },
            {
              id:8,
              Q:"What is the repayment tenor of supply chain finance? ",
              A:"The repayment tenor of supply chain finance is 12 months. As per the business requirements, it can also be extended."
            },
            {
              id:9,
              Q:"What are the types of SME loans for supply chain finance? ",
              A:"The four common types of SME loans for supply chain finance are invoice financing, purchase order financing, supply chain financing, and inventory financing."
            },
            {
              id:10,
              Q:"How is the interest rate calculated and finalized by the company providing supply chain finance?",
              A:"The supply chain finance company calculates the interest rate based on how much of the credit limit the client has used up. "
            },
            {
              id:11,
              Q:"How many limits can a business avail from supply chain finance? ",
              A:"A business can receive up to 80% to 85% of the total value of the invoice. It also depends on the specific requirements and eligibility criteria set by the supply chain finance company. "
            }
      ],
    },
   
  
}